module.exports = __webpack_public_path__ + "img/pageLeft.8dbff75d.svg";